import AclModule from "@/common/module/acl";
import KeyCloak from "@/common/module/keyCloak";
import { IAccount } from "@/common/services/cas/interfacesCas";

export interface ISubItem {
  name: string;
  href: string;
  dataTestQa?: string;
  active: boolean;
}
export interface IItem {
  name?: string;
  title?: string;
  icon: string;
  href?: string;
  active: boolean;
  dataTestQa?: string;
  subItems?: ISubItem[];
}

export interface ISidebarItems {
  title: string;
  active: boolean;
  items: IItem[];
}

export const infoDetails = [
  {
    title: "Feature Flag",
    columns: [
      { field: "menu", header: "Nome do Menu" },
      { field: "name", header: "Nome do Feature Flag" },
    ],
    values: [
      {
        menu: "Receita",
        name: "module-revenue.read",
      },
      {
        menu: "Geral",
        name: "module-mexp-configurations.integration",
      },
      {
        menu: "Performance Whatsapp",
        name: "whatsapp_campaign",
      },
      {
        menu: "Campanha Whatsapp",
        name: "whatsapp_campaign",
      },
      {
        menu: "OFFSITE",
        name: "Check if account is Wake Store",
      },
      {
        menu: "Jornadas",
        name: "ENV_NOT_PROD | module-mexp-campaign.workflow",
      },
      {
        menu: "SMS",
        name: "sms_campaign",
      },
      {
        menu: "Configurações",
        name: "ENV_NOT_PROD | module-mexp-configurations.integration",
      },
      {
        menu: "Integrações",
        name: "ENV_NOT_PROD | module-mexp-configurations.integration",
      },
      {
        menu: "EMBEDDED WA",
        name: "ENV_NOT_PROD | embedded.whatsapp",
      },
      {
        menu: "USO INTERNO",
        name: "ENV_NOT_PROD",
      },
    ],
  },
];

export function getSidebarItems(param: boolean): {
  sidebar: ISidebarItems[];
  sidebarBemax: ISidebarItems[];
} {
  const account: IAccount = JSON.parse(localStorage.getItem("ACCOUNT") || "{}");
  const checkAccountMock =
    account.code &&
    account.code.customerId === "b3c064cc-353a-4b89-918f-efc17a51882e";

  const sidebar: ISidebarItems[] = [
    {
      title: "INSIGHTS",
      active: true,
      items: [
        {
          name: "Visão Geral",
          icon: "icon-nav-insight",
          href: "/",
          active: true,
        },
        {
          name: "Receita",
          icon: "icon-nav-coin",
          href: "/receita",
          active: AclModule.featureFlag("module-revenue.read"),
        },
        {
          name: "Pessoas",
          icon: "icon-nav-user",
          href: "/base-de-pessoas",
          active: true,
        },
        {
          name: "Perfil de Compra",
          icon: "icon-nav-user_shop",
          href: "/perfil-de-compra",
          active: true,
        },
        {
          title: "Performance",
          icon: "icon-nav-heart",
          active: true,
          subItems: [
            {
              name: "Geral",
              href: "/performance/geral",
              active: true,
            },
            {
              name: "E-mail",
              href: "/performance/email",
              active: KeyCloak.permissionPage("performance_e-mail"),
            },
            {
              name: "WhatsApp",
              href: "/performance/whatsapp",
              active: KeyCloak.permissionPage("performance_whatsApp"),
            },
            {
              name: "SMS",
              href: "/performance/sms",
              active:
                KeyCloak.permissionPage("performance_sms") || checkAccountMock,
            },
            {
              name: "Aplicativo",
              href: "/performance/app",
              active:
                AclModule.featureFlag("ENV_NOT_PROD") ||
                AclModule.featureFlag("app-crm.app"),
            },
            {
              name: "App Push",
              href: "/performance/app-push",
              active: KeyCloak.permissionPage("performance_app_push"),
            },
            {
              name: "Web Push",
              href: "/performance/web-push",
              active: KeyCloak.permissionPage("performance_web_push"),
            },
            {
              name: "Onsite Message",
              href: "/performance/onsite-message",
              active: KeyCloak.permissionPage("performance_onsite_message"),
            },
            {
              name: "Push Optin",
              href: "/performance/push-optin",
              active: KeyCloak.permissionPage("performance_push_optin"),
            },
            {
              name: "Lightbox",
              href: "/performance/lightbox",
              active: KeyCloak.permissionPage("performance_lightbox"),
            },
            {
              name: "Jornadas",
              href: "/performance/jornadas",
              active:
                KeyCloak.featureFlag("ENV_NOT_PROD") ||
                KeyCloak.featureFlag("module-xp-zap.journey"),
            },
          ],
        },
      ],
    },
    {
      title: "EXPERIÊNCIAS",
      active: true,
      items: [
        {
          title: "Campanhas",
          icon: "icon-nav-campaign",
          dataTestQa: "Campaign",
          active: true,
          subItems: [
            {
              name: "Offsite",
              href: "/campanhas/offsite",
              dataTestQa: "Create-Campaign",
              active: true,
            },
            {
              name: "E-mail",
              href: "/campanhas/email",
              active: false,
            },
            {
              name: "WhatsApp",
              href: "/campanhas/whatsapp",
              active: false,
            },
            {
              name: "SMS",
              href: "/campanhas/sms",
              active: false,
            },
            {
              name: "Landing Pages",
              href: "/campanhas/landing-page",
              active:
                AclModule.featureFlag("ENV_NOT_PROD") ||
                AclModule.featureFlag("landing_page_smb"),
            },
          ],
        },
        {
          name: "Jornadas",
          icon: "icon-nav-workflow",
          href: "/jornadas",
          active:
            KeyCloak.featureFlag("ENV_NOT_PROD") ||
            KeyCloak.featureFlag("module-mexp-campaign.workflow") ||
            KeyCloak.featureFlag("module-xp-zap.journey"),
        },
      ],
    },
    {
      title: "ESTRATÉGIAS",
      active: true,
      items: [
        {
          name: "Audiências",
          icon: "icon-nav-group",
          href: "/audiencias",
          active: true,
        },
        {
          name: "Studio",
          icon: "icon-nav-studio",
          href: "/studio",
          active: true,
        },
      ],
    },
    {
      title: "CONFIGURAÇÕES",
      active: true,
      items: [
        {
          name: "Integrações",
          icon: "icon-nav-app",
          href: "/integracoes-v2",
          active: !AclModule.featureFlag("ENV_WAKE_STORE"),
        },
        {
          name: "Importações",
          icon: "icon-nav-upload",
          href: "/importacoes/lista",
          active:
            KeyCloak.featureFlag("ENV_NOT_PROD") ||
            KeyCloak.featureFlag("module-config.upload"),
        },
        {
          title: "CRM",
          icon: "icon-nav-mobile",
          active: AclModule.featureFlag("ENV_NOT_PROD"),
          subItems: [
            {
              name: "Vendedores",
              href: "/crm-sellers",
              active: true,
            },
          ],
        },
        {
          name: "Canais",
          icon: "icon-nav-channels",
          href: "/channels/list",
          active: true,
        },
      ],
    },
    {
      title: "AJUDA",
      active:
        KeyCloak.featureFlag("ENV_NOT_PROD") ||
        KeyCloak.featureFlag("intern-use.tickets"),
      items: [
        {
          name: "Solicitações",
          icon: "icon-nav-campaign",
          href: "/solicitacoes",
          active:
            KeyCloak.featureFlag("ENV_NOT_PROD") ||
            KeyCloak.featureFlag("intern-use.tickets"),
        },
      ],
    },
    {
      title: "USO INTERNO",
      active:
        KeyCloak.featureFlag("ENV_NOT_PROD") ||
        KeyCloak.featureFlag("intern-use.input-data"),
      items: [
        {
          name: "Input de dados",
          icon: "icon-nav-report",
          href: "/input-dados",
          active:
            KeyCloak.featureFlag("ENV_NOT_PROD") ||
            KeyCloak.featureFlag("intern-use.input-data"),
        },
      ],
    },
  ];

  const sidebarBemax: ISidebarItems[] = [
    {
      title: "FERRAMENTAS BEMAX",
      active: true,
      items: [
        {
          name: "Insights BeMax",
          icon: "icon-nav-insight",
          href: "/guru-jornadas",
          active: true,
        },
      ],
    },
  ];

  return {
    sidebar,
    sidebarBemax,
  };
}
